import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../context/NotificationContext';
import { useSettings } from '../context/SettingsContext';

// ─── Renk hash'i (telefon/isme göre tutarlı renk) ────────────────────────────
const nameToColor = (str = '') => {
    const palette = [
        '#25D366', '#128C7E', '#075E54', '#34B7F1',
        '#6366f1', '#8b5cf6', '#ec4899', '#f59e0b',
        '#ef4444', '#10b981', '#06b6d4', '#f97316'
    ];
    let hash = 0;
    for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
    return palette[Math.abs(hash) % palette.length];
};

const getInitials = (name = '', phone = '') => {
    if (name && name.trim()) {
        const parts = name.trim().split(' ');
        if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
        return parts[0].slice(0, 2).toUpperCase();
    }
    return (phone || '?').slice(-2);
};

// ─── Avatar bileşeni ─────────────────────────────────────────────────────────
export const ContactAvatar = ({ name, phone, photoUrl, size = 40, fontSize = 16 }) => {
    const color = nameToColor(name || phone || '');
    const initials = getInitials(name, phone);

    if (photoUrl) {
        return (
            <img
                src={photoUrl}
                alt={name || phone}
                style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
            />
        );
    }

    return (
        <div style={{
            width: size, height: size, borderRadius: '50%', flexShrink: 0,
            background: `linear-gradient(135deg, ${color}, ${color}cc)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 700, fontSize,
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            userSelect: 'none'
        }}>
            {initials}
        </div>
    );
};

// ─── Bildirim Paneli ──────────────────────────────────────────────────────────
const NotificationPanel = ({ onClose }) => {
    const { notifications, unreadWA, dismiss, formatReminderTime } = useNotifications();
    const { isModuleActive } = useSettings();
    const waActive = isModuleActive('whatsapp');

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const overdueList = notifications.filter(n => n.type === 'overdue' || new Date(n.Hatirlatma_Tarihi) < new Date());
    const upcomingList = notifications.filter(n => new Date(n.Hatirlatma_Tarihi) >= new Date());

    const isEmpty = notifications.length === 0 && (!waActive || unreadWA === 0);

    return (
        <div style={{
            position: 'absolute', right: 0, top: 'calc(100% + 8px)',
            width: '360px', background: '#fff', borderRadius: '14px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)', border: '1px solid #e5e7eb',
            zIndex: 9999, overflow: 'hidden'
        }}>
            {/* Başlık */}
            <div style={{ padding: '14px 16px', background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontWeight: 700, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="feather-bell"></i>
                    Bildirimler
                    {(notifications.length + (unreadWA > 0 ? 1 : 0)) > 0 && (
                        <span style={{ background: '#ef4444', borderRadius: '10px', fontSize: '11px', padding: '1px 7px', fontWeight: 700 }}>
                            {notifications.length + (unreadWA > 0 ? 1 : 0)}
                        </span>
                    )}
                </div>
                <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.8)', cursor: 'pointer', padding: '2px' }}>
                    <i className="feather-x" style={{ fontSize: '16px' }}></i>
                </button>
            </div>

            <div style={{ maxHeight: '420px', overflowY: 'auto' }}>
                {/* WhatsApp okunmamış */}
                {waActive && unreadWA > 0 && (
                    <a href="./whatsapp-inbox" style={{ textDecoration: 'none' }}>
                        <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', gap: '12px', alignItems: 'center', background: '#f0fdf4', cursor: 'pointer' }}
                            className="notification-item">
                            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <i className="bi bi-whatsapp text-white" style={{ fontSize: '18px' }}></i>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 700, fontSize: '13px', color: '#111' }}>
                                    {unreadWA} okunmamış WhatsApp mesajı
                                </div>
                                <div style={{ fontSize: '11px', color: '#25D366', fontWeight: 600 }}>Gelen kutusuna git →</div>
                            </div>
                        </div>
                    </a>
                )}

                {/* Geçmiş hatırlatmalar */}
                {overdueList.length > 0 && (
                    <div>
                        <div style={{ padding: '6px 16px', background: '#fef9c3', fontSize: '10px', fontWeight: 700, color: '#92400e', letterSpacing: '0.5px' }}>
                            ⚠️ GEÇEN HATIRLATMALAR
                        </div>
                        {overdueList.map(n => (
                            <div key={`${n.Form_ID}_o`} style={{ padding: '10px 16px', borderBottom: '1px solid #fef9c3', display: 'flex', gap: '10px', alignItems: 'flex-start', background: '#fffbeb' }}>
                                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <i className="feather-clock" style={{ fontSize: '16px', color: '#f59e0b' }}></i>
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: 700, fontSize: '12px', color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {n.Adi_Soyadi}
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#888', marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {n.Aciklama || 'Hatırlatma'}
                                    </div>
                                    <div style={{ fontSize: '10px', color: '#f59e0b', fontWeight: 600, marginTop: '2px' }}>
                                        {new Date(n.Hatirlatma_Tarihi).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                                    <a href={`./lead-detail?id=${n.Form_ID}`}
                                        style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#dbeafe', borderRadius: '6px', color: '#1d4ed8', textDecoration: 'none' }}>
                                        <i className="feather-external-link" style={{ fontSize: '12px' }}></i>
                                    </a>
                                    <button onClick={() => dismiss(n.Form_ID)}
                                        style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fee2e2', borderRadius: '6px', color: '#dc2626', border: 'none', cursor: 'pointer' }}>
                                        <i className="feather-x" style={{ fontSize: '12px' }}></i>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Yaklaşan hatırlatmalar */}
                {upcomingList.length > 0 && (
                    <div>
                        <div style={{ padding: '6px 16px', background: '#f0f9ff', fontSize: '10px', fontWeight: 700, color: '#075985', letterSpacing: '0.5px' }}>
                            🗓 YAKLAŞAN HATIRLATMALAR
                        </div>
                        {upcomingList.map(n => {
                            const remDate = new Date(n.Hatirlatma_Tarihi);
                            const isUrgent = (remDate - new Date()) < 60 * 60 * 1000;
                            return (
                                <div key={`${n.Form_ID}_u`} style={{ padding: '10px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', gap: '10px', alignItems: 'flex-start', background: isUrgent ? '#fff1f2' : '#fff' }}>
                                    <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: isUrgent ? '#fee2e2' : '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <i className="feather-bell" style={{ fontSize: '16px', color: isUrgent ? '#ef4444' : '#3b82f6' }}></i>
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontWeight: 700, fontSize: '12px', color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {n.Adi_Soyadi}
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#888', marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {n.Aciklama || 'Hatırlatma'}
                                        </div>
                                        <div style={{ fontSize: '10px', color: isUrgent ? '#ef4444' : '#6366f1', fontWeight: 600, marginTop: '2px' }}>
                                            {formatReminderTime(n.Hatirlatma_Tarihi)}
                                            {' · '}
                                            {remDate.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                                        <a href={`./lead-detail?id=${n.Form_ID}`}
                                            style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#dbeafe', borderRadius: '6px', color: '#1d4ed8', textDecoration: 'none' }}>
                                            <i className="feather-external-link" style={{ fontSize: '12px' }}></i>
                                        </a>
                                        <button onClick={() => dismiss(n.Form_ID)}
                                            style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6', borderRadius: '6px', color: '#6b7280', border: 'none', cursor: 'pointer' }}>
                                            <i className="feather-x" style={{ fontSize: '12px' }}></i>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {isEmpty && (
                    <div style={{ padding: '32px 16px', textAlign: 'center', color: '#aaa' }}>
                        <i className="feather-check-circle" style={{ fontSize: '32px', color: '#d1d5db', display: 'block', marginBottom: '8px' }}></i>
                        <div style={{ fontSize: '13px' }}>Tüm bildirimler temiz</div>
                    </div>
                )}
            </div>

            {/* Alt link */}
            {notifications.length > 0 && (
                <div style={{ padding: '10px 16px', borderTop: '1px solid #f0f0f0', textAlign: 'center' }}>
                    <a href="./forms" style={{ fontSize: '12px', color: '#6366f1', textDecoration: 'none', fontWeight: 600 }}>
                        Tüm Leadleri Gör →
                    </a>
                </div>
            )}
        </div>
    );
};

// ─── Ana Header ───────────────────────────────────────────────────────────────
const Header = () => {
    const { user } = useAuth();
    const { totalBadge, isOpen, setIsOpen } = useNotifications();
    const panelRef = useRef(null);

    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };

    const changeTheme = () => {
        const currentTheme = localStorage.getItem("app-skin-dark") || "app-skin-light";
        if (currentTheme === "app-skin-dark") {
            $(".dark-button").hide().addClass("active");
            $(".light-button").show().removeClass("active");
            $("html").addClass("app-skin-dark");
        } else {
            $(".light-button").hide().addClass("active");
            $(".dark-button").show().removeClass("active");
            $("html").addClass("app-skin-light");
        }
    };

    const handleDarkTheme = (e) => {
        e.preventDefault();
        $(".dark-button").hide().addClass("active");
        $(".light-button").show().removeClass("active");
        $("html").removeClass("app-skin-light").addClass("app-skin-dark");
        localStorage.setItem("app-skin-dark", "app-skin-dark");
    };

    const handleLightTheme = (e) => {
        e.preventDefault();
        $(".light-button").hide().addClass("active");
        $(".dark-button").show().removeClass("active");
        $("html").removeClass("app-skin-dark").addClass("app-skin-light");
        localStorage.setItem("app-skin-dark", "app-skin-light");
    };

    // Dışarı tıklayınca kapat
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (panelRef.current && !panelRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, setIsOpen]);

    useEffect(() => {
        changeTheme();
        $(".dark-button").on("click", handleDarkTheme);
        $(".light-button").on("click", handleLightTheme);
        $("[data-style='reset-app-skin']").on("click", function (e) {
            e.preventDefault();
            localStorage.removeItem("app-skin-dark");
            window.location.reload(true);
        });
        return () => {
            $(".dark-button").off("click", handleDarkTheme);
            $(".light-button").off("click", handleLightTheme);
            $("[data-style='reset-app-skin']").off("click");
        };
    }, []);

    return (
        <header className="nxl-header">
            <div className="header-wrapper">
                <div className="header-left d-flex align-items-center gap-4">
                    <a href="javascript:void(0);" className="nxl-head-mobile-toggler" id="mobile-collapse">
                        <div className="hamburger hamburger--arrowturn">
                            <div className="hamburger-box">
                                <div className="hamburger-inner"></div>
                            </div>
                        </div>
                    </a>
                    <div className="nxl-navigation-toggle">
                        <a href="javascript:void(0);" id="menu-mini-button">
                            <i className="feather-align-left"></i>
                        </a>
                        <a href="javascript:void(0);" id="menu-expend-button" style={{ display: 'none' }}>
                            <i className="feather-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div className="header-right ms-auto">
                    <div className="d-flex align-items-center gap-1">

                        {/* Tam ekran */}
                        <div className="nxl-h-item d-none d-sm-flex">
                            <a href="javascript:void(0);" className="nxl-head-link me-0" onClick={toggleFullScreen}>
                                <i className="feather-maximize maximize"></i>
                                <i className="feather-minimize minimize"></i>
                            </a>
                        </div>

                        {/* Tema değiştir */}
                        <div className="nxl-h-item dark-light-theme">
                            <a href="javascript:void(0);" className="nxl-head-link me-0 dark-button" onClick={changeTheme}>
                                <i className="feather-moon"></i>
                            </a>
                            <a href="javascript:void(0);" className="nxl-head-link me-0 light-button" style={{ display: 'none' }} onClick={changeTheme}>
                                <i className="feather-sun"></i>
                            </a>
                        </div>

                        {/* 🔔 Bildirim Çanı */}
                        <div className="nxl-h-item" style={{ position: 'relative' }} ref={panelRef}>
                            <button
                                onClick={() => setIsOpen(o => !o)}
                                style={{
                                    position: 'relative', background: 'none', border: 'none', cursor: 'pointer',
                                    width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    borderRadius: '10px', transition: 'background 0.15s',
                                    background: isOpen ? 'rgba(99,102,241,0.1)' : 'none'
                                }}
                                title="Bildirimler"
                            >
                                <i className="feather-bell" style={{ fontSize: '18px', color: isOpen ? '#6366f1' : '#666' }}></i>
                                {totalBadge > 0 && (
                                    <span style={{
                                        position: 'absolute', top: '4px', right: '4px',
                                        minWidth: '16px', height: '16px', background: '#ef4444',
                                        borderRadius: '8px', fontSize: '9px', fontWeight: 800,
                                        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        border: '2px solid #fff', padding: '0 3px',
                                        animation: totalBadge > 0 ? 'pulse 2s infinite' : 'none'
                                    }}>
                                        {totalBadge > 9 ? '9+' : totalBadge}
                                    </span>
                                )}
                            </button>

                            {isOpen && <NotificationPanel onClose={() => setIsOpen(false)} />}
                        </div>

                        {/* Kullanıcı menüsü */}
                        <div className="dropdown nxl-h-item">
                            <a href="javascript:void(0);" data-bs-toggle="dropdown" role="button" data-bs-auto-close="outside">
                                <img src={user.Profil_Gorseli} alt="user-image" className="img-fluid user-avtar me-0" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
                                <div className="dropdown-header">
                                    <div className="d-flex align-items-center">
                                        <img src={user.Profil_Gorseli} alt="user-image" className="img-fluid user-avtar" />
                                        <div>
                                            <h6 className="text-dark mb-0">
                                                {user.Kullanici_Adi} {user.Kullanici_Soyadi}
                                                <span className="badge bg-soft-success text-success ms-1">
                                                    {user.Kullanici_Yetki == 0 ? "ADMIN" : "YETKİLİ"}
                                                </span>
                                            </h6>
                                            <span className="fs-12 fw-medium text-muted">{user.Kullanici_Email}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="dropdown-divider"></div>
                                <a href="./my-account" className="dropdown-item">
                                    <i className="feather-user"></i>
                                    <span>Hesabım</span>
                                </a>
                                <a href="./settings" className="dropdown-item">
                                    <i className="feather-settings"></i>
                                    <span>Ayarlar</span>
                                </a>
                                <div className="dropdown-divider"></div>
                                <a href="./logout" className="dropdown-item">
                                    <i className="feather-log-out"></i>
                                    <span>Çıkış Yap</span>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Pulse animasyonu CSS */}
            <style>{`
                @keyframes pulse {
                    0%, 100% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.2); opacity: 0.85; }
                }
                .notification-item:hover { background: #f0fdf4 !important; }
            `}</style>
        </header>
    );
};

export default Header;
